import React, { useContext } from 'react'
import { GETNET, OTHERS, WEBPAY } from '../../constants/payment'
import { usePayment } from '../../hook/payment/usePayment/usePayment'
import PropTypes from 'prop-types'
import { useNativePayment } from '../../hook/payment/useNativePayment'
import { OthersPaymentForm, SaveCardForm } from '@pinflag/pinflag-ui-kit'
import { paymentLogos } from '../../constants/payment-logos'
import { PAYMENT_METHOD_TRANSLATION } from '../../constants/translation'
import { DataContext } from '../../context/DataContext'

const parseCmsPaymentMethods = (
  cmsPaymentMethods,
  companyName,
  selectedPaymentMethod
) => {
  // Return an object with the shape { logo: url, name: string, code: string }
  return cmsPaymentMethods.map((paymentMethod) => ({
    logo:
      paymentLogos(companyName)[paymentMethod.code]?.logo ||
      paymentLogos(companyName).checkmo.logo,
    logoWidth:
      paymentLogos(companyName)[paymentMethod.code]?.width ||
      paymentLogos(companyName).checkmo.width,
    name:
      (PAYMENT_METHOD_TRANSLATION[companyName] &&
        PAYMENT_METHOD_TRANSLATION[companyName][paymentMethod.title]) ||
      paymentMethod.title,
    isSelected: selectedPaymentMethod === paymentMethod.code,
    code: paymentMethod.code
  }))
}

const PaymentMethodForm = ({ gateway, scrapperClient }) => {
  const {
    isSavingCard,
    setIsSavingCard,
    selectedPaymentOption,
    hasConfirmedPaymentMethod,
    nativePaymentEnabled
  } = usePayment()

  const { cmsPaymentMethods, companyInfo } = useContext(DataContext)
  const { companyName } = companyInfo
  const enableNativeLogicForTheFirstTime =
    gateway === OTHERS && nativePaymentEnabled
  const { selectedNativePaymentMethod, handlePaymentMethod } = useNativePayment(
    { scrapperClient, effectsActive: enableNativeLogicForTheFirstTime }
  )

  const nativePaymentMethods = parseCmsPaymentMethods(
    cmsPaymentMethods,
    companyName,
    selectedNativePaymentMethod
  )

  const isPayingWithCreditCard = selectedPaymentOption === 'credit'

  if (gateway === OTHERS) {
    return (
      <OthersPaymentForm
        paymentMethods={nativePaymentMethods}
        setSelectedPaymentMethod={handlePaymentMethod}
      />
    )
  } else if (gateway === GETNET || gateway === WEBPAY) {
    return (
      <SaveCardForm
        disabled={hasConfirmedPaymentMethod}
        isCreditCard={isPayingWithCreditCard}
        isSavingCard={isSavingCard}
        onSaveCard={() => setIsSavingCard(!isSavingCard)}
      />
    )
  }
  return null
}

PaymentMethodForm.propTypes = {
  gateway: PropTypes.string,
  scrapperClient: PropTypes.string
}

export default PaymentMethodForm
